import { render, staticRenderFns } from "./fantaslinkinfo.vue?vue&type=template&id=52e30420"
import script from "./fantaslinkinfo.ts?vue&type=script&lang=js&external"
export * from "./fantaslinkinfo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports